/**
 * 模块名：H5基础js
 * 包含方法：
 * 1、DYBrowser 客户端识别
 * @author wangyawei@douyu.tv
 * @update huangyuwei by 2017-04-03
 */

/**
 * 环境判断
 */
const DYBrowser = (function () {
    const _UA = navigator.userAgent.toLowerCase();

    return {
        isMobile: !!(/Android|webOS|iPhone|iPod|iPad|BlackBerry/i.test(_UA) || _UA.match(/Douyu_Android/i) || _UA.match(/Douyu_IOS/i)), // 是否为移动终端
        isWX: !!_UA.match(/MicroMessenger/i), // 在微信中打开
        isWB: !!_UA.match(/WeiBo/i), // 在新浪微博客户端打开
        isQQ: !!(_UA.match(/QQ/i) && ((_UA.indexOf('yyb_d') > -1 || _UA.indexOf('yybd') > -1))) || /UIWebView/i.test(_UA), // 在QQ内置浏览器打开
        isDyAndroid: !!_UA.match(/Douyu_Android/i), // 在斗鱼Android客户端打开
        isDyIOS: !!_UA.match(/Douyu_IOS/i), // 在斗鱼IOS客户端打开
        isIOS: !!_UA.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/i), // ios终端
        isIOSHD: !!_UA.match(/ipad/i) // ipad终端
    };
}());

export default DYBrowser;
